import React from 'react';

import { toast } from '@core/toast';

import { ConfirmationModal } from '@components/confirmation-modal';
import { Api } from '@core/api';
import { injectTSDI } from '@core/tsdi';

import { CompositePointDefinitionDto } from '@api/FitnessActivityClient';

interface Props {
    definition: CompositePointDefinitionDto | null;
    onClose(): void;
    onSuccess(): void;
}

export function DeletePointDefinitionDialog({
    definition,
    onClose,
    onSuccess
}: Props) {
    const { fitnessActivityClient } = injectTSDI(Api);

    const handleDelete = async () => {
        if (!definition) {
            return false;
        }
        await fitnessActivityClient.admin.compositePointDefinitionControllerDelete(
            definition.id
        );
        toast.success('Point definition deleted');
        onSuccess();
        return false;
    };

    return (
        <ConfirmationModal
            open={Boolean(definition)}
            title="Delete Point Definition"
            buttonText="Delete"
            destructive
            onModalClose={onClose}
            submitHandler={handleDelete}
        >
            <p className="text-sm">
                Are you sure you want to delete definition &quot;
                {definition?.pointTypeKey}&quot;? This action cannot be undone.
            </p>
        </ConfirmationModal>
    );
}
